import { render, staticRenderFns } from "./ImageBotResponse.vue?vue&type=template&id=1b39b166&scoped=true"
import script from "./ImageBotResponse.vue?vue&type=script&lang=js"
export * from "./ImageBotResponse.vue?vue&type=script&lang=js"
import style0 from "./ImageBotResponse.vue?vue&type=style&index=0&id=1b39b166&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b39b166",
  null
  
)

export default component.exports